import React from 'react';
import {
  gridtitle,
  gridContainer,
  company_gridContainer,
  content,
  check
} from './KycBREReport.module.css';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import moment from 'moment';

const KycBreReportInd = ({
  type,
  nameData,
  companyData,
  companyGstData,
  gstStatus,
  applicantType
}) => {
  const gridValue = 'text-black-1026 text-xs font-open-sans-semi-bold mt-1';
  const gridTitle = `text-grey-2241 text-xs ${gridtitle} `;
  const rules = {
    name: {
      ruleName: 'Name',
      col1: 'Name',
      col2: 'Name'
    },
    dob: {
      ruleName: 'DOB',
      col1: 'DOB',
      col2: 'DOB'
    }
  };
  return (
    <div className="w-full border-navy-1002 border rounded shadow-inner shadow-md font-open-sans px-3 py-3">
      <p className="font-open-sans-bold text-lg text-black-1011">
        {applicantType === 'MAIN_APPLICANT' ? 'Main Applicant' : 'Co Applicant'}
      </p>
      {nameData?.map(each => (
        <div className="w-full bg-navy-300 rounded px-3 py-2 mt-4 ">
          <div className="w-full flex items-center px-2 pt-3">
            <p className="text-black-1015 text-base font-open-sans-semi-bold capitalize">
              {each?.breKycName}
            </p>
            <p className="ml-auto float-right clear-both text-xs text-lynch-100">
              {moment(each?.updateAt).format('DD MMM, YY hh:mm A')}
            </p>
          </div>
          <hr className="text-navy-1002 my-3 w-full" />
          <div className={`${gridContainer}`}>
            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>
                {rules?.[each?.breKycName]?.col1} (As per
                <span>{`${each?.docName1}`.replace(/_/g, ' ')}</span>)
              </p>
              <p className={gridValue}>{each?.valueAsPerDoc1}</p>
            </div>

            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>
                {rules?.[each?.breKycName]?.col1} (As per
                <span className="ml-1">
                  {`${each?.docName2}`.replace(/_/g, ' ')}
                </span>
                )
              </p>
              <p className={gridValue}>{each?.valueAsPerDoc2}</p>
            </div>

            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Percentage needed</p>
              <p className={gridValue}>{each?.percetageNeeded || 0}%</p>
            </div>

            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Current Percentage</p>
              <p className={gridValue}>{each?.percetagechecked || 0}%</p>
            </div>

            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Status</p>
              <p className=" text-base font-open-sans-bold capitalize">
                {each?.statusAccepted ? (
                  <span className="items-center text-green-mountainMeadow">
                    <CheckIcon
                      className={` ${check} text-green-mountainMeadow text-base mr-1`}
                    />
                    Accepted
                  </span>
                ) : (
                  <span className="items-center text-red-sunsetOrange">
                    <ClearIcon
                      className={` ${check} text-red-sunsetOrange text-base mr-1`}
                    />
                    Rejected
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
      ))}
      <div className="w-full bg-navy-300 rounded px-3 py-2 mt-4 ">
        <div className="w-full flex items-center px-2 pt-3">
          <p className="text-black-1015 text-base font-open-sans-semi-bold capitalize">
            Company
          </p>
        </div>
        <hr className="text-navy-1002 my-3 w-full" />
        <div className={`${company_gridContainer}`}>
          <div className={`${content} w-full px-3 py-2 text-left`}>
            <p className={gridTitle}>Company Name</p>
            <p className={gridValue}>{companyData?.companyName}</p>
          </div>

          <div className={`${content} w-full px-3 py-2 text-left`}>
            <p className={gridTitle}>Company Type</p>
            <p className={gridValue}>{companyData?.companyType}</p>
          </div>
          <div className={`${content} w-full px-3 py-2 text-left`}>
            <p className={gridTitle}>Status</p>
            <p className=" text-base font-open-sans-bold capitalize">
              {companyData?.statusAccepted ? (
                <span className="items-center text-green-mountainMeadow">
                  <CheckIcon
                    className={` ${check} text-green-mountainMeadow text-base mr-1`}
                  />
                  Accepted
                </span>
              ) : (
                <span className="items-center text-red-sunsetOrange">
                  <ClearIcon
                    className={` ${check} text-red-sunsetOrange text-base mr-1`}
                  />
                  Rejected
                </span>
              )}
            </p>
          </div>
        </div>
      </div>
      {gstStatus?.isGst ? (
        <div className="w-full bg-navy-300 rounded px-3 py-2 mt-4 ">
          <div className="w-full flex items-center px-2 pt-3">
            <p className="text-black-1015 text-base font-open-sans-semi-bold capitalize">
              GST
            </p>
          </div>
          <hr className="text-navy-1002 my-3 w-full" />
          <div className={`${company_gridContainer}`}>
            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Company Name</p>
              <p className={gridValue}>{companyGstData?.companyName}</p>
            </div>

            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Company Name From GST</p>
              <p className={gridValue}>{companyGstData?.companyNameFromGst}</p>
            </div>
            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Gst Number</p>
              <p className={gridValue}>{companyGstData?.gstNumber}</p>
            </div>
            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Status</p>
              <p className=" text-base font-open-sans-bold capitalize">
                {companyGstData?.statusAccepted ? (
                  <span className="items-center text-green-mountainMeadow">
                    <CheckIcon
                      className={` ${check} text-green-mountainMeadow text-base mr-1`}
                    />
                    Accepted
                  </span>
                ) : (
                  <span className="items-center text-red-sunsetOrange">
                    <ClearIcon
                      className={` ${check} text-red-sunsetOrange text-base mr-1`}
                    />
                    Rejected
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full bg-navy-300 rounded px-3 py-2 mt-4 ">
          <div className="w-full flex items-center px-2 pt-3">
            <p className="text-black-1015 text-base font-open-sans-semi-bold capitalize">
              GST
            </p>
          </div>
          <hr className="text-navy-1002 my-3 w-full" />
          <div className={`${company_gridContainer}`}>
            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Company Name</p>
              <p className={gridValue}>{gstStatus?.companyName}</p>
            </div>

            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>GST Number</p>
              <p className={gridValue}>NA</p>
            </div>
            <div className={`${content} w-full px-3 py-2 text-left`}>
              <p className={gridTitle}>Status</p>
              <p className=" text-base font-open-sans-bold capitalize">
                {gstStatus?.statusAccepted ? (
                  <span className="items-center text-green-mountainMeadow">
                    <CheckIcon
                      className={` ${check} text-green-mountainMeadow text-base mr-1`}
                    />
                    Accepted
                  </span>
                ) : (
                  <span className="items-center text-red-sunsetOrange">
                    <ClearIcon
                      className={` ${check} text-red-sunsetOrange text-base mr-1`}
                    />
                    Rejected
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KycBreReportInd;
